import React, { useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Footer from "../../components/Footer/Footer";
import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { experimentalStyled as styled } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";
import AppDevelopment from "../../../src/Assets/Images/WebDevelopment/5016 1.webp";
import AppVideo from "../../../src/Assets/Video/UIUXVideo.mp4";

import servicelogo1 from "../../../src/Assets/Images/Servicesinnerpageicons/Uiux/image 49.webp";
import servicelogo2 from "../../../src/Assets/Images/Servicesinnerpageicons/Uiux/image 50.webp";
import servicelogo3 from "../../../src/Assets/Images/Servicesinnerpageicons/Uiux/image 51.webp";
import servicelogo4 from "../../../src/Assets/Images/Servicesinnerpageicons/Uiux/image 52.webp";
import servicelogo5 from "../../../src/Assets/Images/Servicesinnerpageicons/Uiux/image 53.webp";
import servicelogo6 from "../../../src/Assets/Images/Servicesinnerpageicons/Uiux/image 54.webp";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";

const content = [
  "Understanding the Business",
  "Research the competition",
  "Bring ideas to life",
  "Wireframing and Designing",
  "Prototyping the Design",
  "Test User Experience",
];

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

function Uiuxinner() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Professional UI/UX Design Services | Custom Web & Mobile Design - Dwebbox</title>
        <meta
          name="description"
          content="Create intuitive, user-friendly digital experiences with Dwebbox's professional UI/UX design services. We specialize in wireframing, prototyping, and user testing."
        />
        <meta name="keywords" content="UI/UX design, custom design, user experience agency, wireframing, prototyping, user testing, web design" />
        <link rel="canonical" href="https://dwebbox.com/uiux" />
      </Helmet>
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <div>
        <Box sx={{ width: "100%", background: "#181818" }}>
          <Container
            component="main"
            sx={{ pt: 8, pb: 8, background: "#181818" }}
          >
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "20px",
                fontFamily: "DM Sans_18pt-ExtraLight",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "18px",
                },
              }}
            >
              <span
                style={{
                  content: "''",
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  background: "white",
                  marginRight: "5px",
                }}
              ></span>{" "}
              Our Services {/* Add a span with the bullet class */}
            </Typography>
            <Typography
              variant="h1"
              sx={{
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                fontSize: "70px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              UI/UX Designing
            </Typography>
            <Typography
              variant="h2"
              sx={{
                color: "#ffffff",
                marginTop: "10vh",
                display: "flex",
                alignItems: "center",
                fontSize: "42px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              Crafting seamless experiences, one pixel at a time, elevate
              digital journeys{" "}
            </Typography>
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "24px",
                marginTop: "5vh",
                fontWeight: "250",
                fontFamily: "DM Sans_18pt-ExtraLight",
                width: "95%",
              }}
            >
              Design and user experience that your customers will never forget.
              Create your product design from scratch or revamp your old UI/UX
              with the most creative minds at your disposal. best of what your
              company offers.
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: "#ffffff",
                marginTop: "10vh",
                display: "flex",
                alignItems: "center",
                fontSize: "32px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              Here is the six-step process we follow to create the ideal website
              for you to engage with your customers online:
            </Typography>
          </Container>

          <Container
            component="main"
            sx={{
              pt: 3,
              pb: 5,
              background: "#181818",
              display: "flex",
              justifyContent: "space-between",
              height: "80vh",
              "@media (max-width:600px)": {
                // Styles for screens with a maximum width of 600px (mobile view)
                flexDirection: "column",
                height: "130vh",
              },
            }}
          >
            <Box
              sx={{
                background: "#ffffff",
                width: "40%",
                height: "90%",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  width: "90%",
                  marginBottom: "5vh",
                  height: "40%",
                },
              }}
            >
              <video
                src={AppVideo}
                autoPlay
                loop
                muted
                playsinline
                style={{ width: "100%", height: "100%", background: "#121212" }}
                alt=""
              />
            </Box>

            <Box
              sx={{
                width: "55%",
                height: "90%",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  width: "90%",
                },
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 0 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  className="inner-page-itemgrid"
                >
                  {[
                    servicelogo1,
                    servicelogo2,
                    servicelogo3,
                    servicelogo4,
                    servicelogo5,
                    servicelogo6,
                  ].map((serviceLogo, index) => (
                    <Grid item xs={2} sm={4} md={4} key={index}>
                      <Item
                        sx={{
                          borderRadius: "0",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                          background: "#181818",
                          height: "30vh",
                          "@media (max-width:600px)": {
                            // Styles for screens with a maximum width of 600px (mobile view)
                            height: "22vh",
                            width: "111%",
                            textAlign: "center",
                          },
                        }}
                      >
                        <img
                          src={serviceLogo}
                          alt={`Service Logo ${index + 1}`}
                          style={{ maxWidth: "67px", maxHeight: "67px" }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#ffffff",
                            fontSize: "16px",
                            fontWeight: "600",
                            fontFamily: "Epilogue",
                            "@media (max-width:600px)": {
                              // Styles for screens with a maximum width of 600px (mobile view)
                              fontSize: "12px",
                              fontWeight: "500",
                              marginTop: "1vh",
                              textAlign: "center",
                            },
                          }}
                        >
                          {content[index]}
                        </Typography>
                      </Item>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </Container>
        </Box>
      </div>
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Uiuxinner;
